<template>
  <div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    我是趋势图
  </div>
</template>

<script>
  import api from '@/utils/type.js'

  import {
    Method_EasySelect,
    Method_EasyAdd
  } from '@/utils/loadhttpdata.js';

  export default {
    name: "oil",
    data() {
      return {
        element_loading: false,




      };
    },
    created: function() {
      // console.log('图片 组件 创建');
      // this.loaddata();
    },
    mounted: function() {
      // console.log('图片 组件 mounted');
    },
    activated: function() {
      // console.log('图片 组件激活时调用 激活');
      // this.loaddata();
    },
    methods: {
      loaddata: function() {
        this.element_loading = true;

        this.$post(
          api.http_method, Method_EasySelect('data_exp_warningcar')
        ).then(res => {
          this.element_loading = false;
          res = JSON.parse(res);
          console.log(res);
          if (res.data.status == 1) {
            let t = res.data.data;


          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
        });
      },
    }


  }
</script>

<style>
</style>
